import { RGBELoader } from 'three/addons/loaders/RGBELoader.js';
import {
  applyHdriToSceneVisual,
  getActiveViewportCamera,
  syncHdriBackgroundForCamera,
} from './ThreeJsUtils/hdriSceneBackground.js';

export const handleHdriSelected = (
  file,
  urll,
  rotationDegrees = 0,
  scene,
  onLoadedCallback,
  hdriVisible = true,
  camera = null,
  lightIntensity = 1
) => {
  const applyHdriToScene = (envMap) => {
    const activeCamera = camera ?? getActiveViewportCamera();
    applyHdriToSceneVisual(
      scene,
      envMap,
      rotationDegrees,
      hdriVisible,
      activeCamera,
      null,
      lightIntensity
    );
    syncHdriBackgroundForCamera(scene, activeCamera);

    if (onLoadedCallback && typeof onLoadedCallback === 'function') {
      onLoadedCallback(envMap);
    }
  };

  if (urll) {
    new RGBELoader().load(urll, (envMap) => {
      applyHdriToScene(envMap);
    });
  } else if (file) {
    const url = URL.createObjectURL(file);
    new RGBELoader().load(url, (envMap) => {
      applyHdriToScene(envMap);
      URL.revokeObjectURL(url);
    });
  }
};
